import { createSelector } from "reselect";

import { selectSalesIntelligenceState } from "app/pages/sales-intelligence/store/selectors";
import { createStatePropertySelector } from "app/pages/workspace/sales/helpers";

const selectMyLists = createStatePropertySelector(selectSalesIntelligenceState("myLists"));
const selectEnrichment = createStatePropertySelector(selectMyLists("enrichment"));

const selectSelectedColumnsConfigObject = selectEnrichment("selectedColumnsConfig");
const selectPreviewObject = selectEnrichment("preview");
const selectParsingObject = selectEnrichment("parsing");
export const selectIsEnriching = selectEnrichment("isEnriching");

export const selectSelectedColumnsConfig = createSelector(
    selectSelectedColumnsConfigObject,
    ({ company }) => company.config,
);
export const selectContactsSelectedColumnsConfig = createSelector(
    selectSelectedColumnsConfigObject,
    ({ contact }) => contact.config,
);

export const selectPreview = createSelector(selectPreviewObject, ({ matchedRows, totalRows }) => ({
    matchedRows,
    totalRows,
}));

export const selectIsLoadingPreview = createSelector(selectPreviewObject, ({ isLoading }) => isLoading);

export const selectParsed = createSelector(selectParsingObject, ({ parsingResult }) => parsingResult);
export const selectContactsParsed = createSelector(
    selectParsingObject,
    ({ contactsParsingResult }) => contactsParsingResult,
);
export const selectIsParsing = createSelector(selectParsingObject, ({ isParsing }) => isParsing);
export const selectParsingError = createSelector(selectParsingObject, ({ error }) => error);
export const selectHasParsingError = createSelector(selectParsingError, (parsingErrors) =>
    Object.values(parsingErrors).some((er) => er === true),
);
